class TabbedNav {
  constructor(el) {
    this.tabbed = el;
    this.tablist = el.querySelector('.c-tabbed-nav__tablist');
    this.tabs = [...this.tablist.querySelectorAll('.c-tabbed-nav__tab-link')];
    this.panels = [...el.querySelectorAll('.c-tabbed-nav__tabpanel')];

    this.switchTab = this.switchTab.bind(this);

    this.setUpEvents();
    this.init();
  }

  // The tab switching function
  switchTab(oldTab, newTab) {
    newTab.focus();

    // Set the selected state
    newTab.setAttribute('aria-selected', 'true');
    oldTab.setAttribute('aria-selected', 'false');
    const index = this.tabs.indexOf(newTab);
    const oldIndex = this.tabs.indexOf(oldTab);
    this.panels[oldIndex].hidden = true;
    this.panels[index].hidden = false;
    newTab.focus();
  }

  setUpEvents() {
    this.tabs.forEach((tab) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', 'false');
      tab.parentNode.setAttribute('role', 'presentation');

      // Handle clicking of tabs for mouse users
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const currentTab = this.tablist.querySelector('[aria-selected="true"]');
        if (e.currentTarget !== currentTab) {
          this.switchTab(currentTab, e.currentTarget);
        }
      });
    });
  }

  init() {
    this.tablist.setAttribute('role', 'tablist');
    this.tablist.setAttribute('aria-orientation', 'vertical');

    // Add tab panel semantics and hide them all
    this.panels.forEach((panel) => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('tabindex', '-1');
      panel.hidden = true;
    });

    // Initially activate the first tab and reveal the first tab panel
    this.tabs[0].removeAttribute('tabindex');
    this.tabs[0].setAttribute('aria-selected', 'true');
    this.panels[0].hidden = false;
  }
}

export function init() {
  const els = document.querySelectorAll('[data-js-tabs]');

  [...els].forEach((el) => new TabbedNav(el));
}
